import { useContext } from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as ArrowSelect } from 'assets/arrow-select.svg';
import i18nContext from 'components/i18n-context';
import './TransitTransactionsTableHead.scss';

export const TRANSIT_TRANSACTIONS_TABLE_HEADER = [
  {
    label: 'transactionId'
  },
  {
    label: 'amount',
    sortBy: 'amount'
  },
  {
    label: 'currency',
    sortBy: 'currency'
  },
  {
    label: 'status',
    sortBy: 'status'
  },
  {
    label: 'statusDetails'
  },
  {
    label: 'direction',
    sortBy: 'direction'
  },
  {
    label: 'externalId',
    sortBy: 'external_id'
  },
  {
    label: 'paymentProvider',
    sortBy: 'transfer_provider'
  },
  {
    label: 'paymentTransactionNumber'
  },
  {
    label: 'providerCreatedAt',
    sortBy: 'provider_created_at'
  },
  {
    label: 'createdAt',
    sortBy: 'created_at'
  },
  {
    label: 'updatedAt',
    sortBy: 'updated_at'
  },
  {
    label: 'actions'
  }
];

const TransitTransactionsTableHead = ({ handleOnSortTable, sortBy, direction }) => {
  const i18n = useContext(i18nContext);

  return (
    <tr>
      {TRANSIT_TRANSACTIONS_TABLE_HEADER.map(
        (head) =>
          head.label && (
            <th key={head.label} className={'transit-transactions-table-head'}>
              <div className={'transit-transactions-table-head-block'}>
                <span>{i18n.getMessage(`transitTransactions.table.header.${head.label}`)}</span>
                {head.sortBy && (
                  <ArrowSelect
                    onClick={() => handleOnSortTable(head.sortBy)}
                    className={`transit-transactions-sorting-arrow-icon ${sortBy === head.sortBy && direction}`}
                  />
                )}
              </div>
            </th>
          )
      )}
    </tr>
  );
};

TransitTransactionsTableHead.propTypes = {
  handleOnSortTable: PropTypes.func,
  sortBy: PropTypes.string,
  direction: PropTypes.string
};

export default TransitTransactionsTableHead;
